import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContextProvider";
import MigrateModal from "../../components/MigrateModal";
import Toggle from "../../components/Toggle";
import BusinessName from "../../components/BusinessName";

const Profile = () => {
  const location = useLocation();
  const inactiveClass = "text-gray-400";
  const activeClass = "text-text-orange";
  const { user, isModalOpen, globalProfile } = useAuth();
  const permissions = user.permissionList;

  const profile = [
    {
      name: "Profile Settings",
      path: "/settings/profile",
    },
    // {
    //   name: "Update KYC",
    //   path: "/settings/profile/kyc-update",
    //   permission: "Upload Document",
    // },
    // {
    //   name: "Upload CAC",
    //   path: "/settings/profile/upload-cac",
    // },
    // {
    //   name: "Upload Identification Document",
    //   path: "/settings/profile/upload-doc",
    // },
    // {
    //   name: "Password",
    //   path: "/settings/profile/password",
    // },
  ];

  const hasUploadPermission = permissions.includes("Upload Document");

  return (
    <div>
      <div className="flex md:items-center flex-col md:flex-row md:justify-between">
        <h1 className="text-2xl font-bold text-navy-blue">
          Settings - Profile
        </h1>
        <Toggle />
      </div>

      {/* <section className="flex md:justify-end text-xl font-bold pt-4 mb-4 pr-4">
        <span className="md:ml-2">
          <BusinessName />
        </span>
      </section> */}

      <div className="md:h-[924px] bg-white mt-8 rounded-[10px] md:p-[3rem] mr-5 md:mr-0">
        <div className="bg-white md:w-[1100px] md:h-[828px] rounded-[10px]">
          {/* <div className="border border-gray-200 rounded-t-[10px] p-[1rem]">
            {/* <div className="flex items-center justify-between px-8">
              {profile?.map((p, index) => {
                if (
                  p.permission === "Upload Document" &&
                  !hasUploadPermission
                ) {
                  return null;
                }
                return (
                  <Link
                    key={index}
                    to={p.path}
                    className={
                      location.pathname === p.path ? activeClass : inactiveClass
                    }
                  >
                    {p?.name}
                  </Link>
                );
              })}
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 6.75L9 11.25L13.5 6.75"
                  stroke="#464255"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div> */}
          {/* </div> */}
          <div>
            <Outlet />
          </div>
        </div>
      </div>
      {isModalOpen && <MigrateModal />}
    </div>
  );
};

export default Profile;
